module.exports = __webpack_public_path__ + "img/icon-select.902d8c48.svg";